<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
	name: 'App'
}
</script>

<style lang="scss">
	@import url("https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,700,700i&display=swap");
	@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed:300,300i,400,400i,700,700i&display=swap");
	@import url("../node_modules/@fortawesome/fontawesome-free/css/all.min.css");
	@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
	@import 'vue-select/src/scss/vue-select.scss';

	body {
		background-color: #F3F7FC;
	}

	#app {
		font: 400 1em/1.625em Roboto Condensed, Roboto, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;

		* {
			box-sizing: border-box;
		}

		.max-width {
			max-width: 1360px;
			margin: 0 auto;
		}

		.hide {
			display: none;
		}

		.submit-form {
			display: flex;
			justify-content: center;
			margin-top: 30px;
		}
	}

	.box-warning {
		position: relative;
		display: block;
		min-height: 35px;
		padding: 5px;
		margin-top: 20px;
		border: 1px solid #CCCE60;
		border-radius: $border-radius;
		color: #333;
		text-align: center;
		background-color: #FBF9CE;

		b {
			font-weight: bold;
		}
	}

	.relatorio {
		position: relative;
		background-color: $inputs-color;
		border-radius: $border-radius;
		text-align: right;

		> a, label {
			position: relative;
			display: inline-block;
			padding: 10px 45px 10px 30px;
			border-radius: 3px;
			font-family: $font-family-alternative;
			background: $success-color;
			color: $inputs-color;
			text-decoration: none;
			font-size: .9em;
			cursor: pointer;

			.fas {
				position: absolute;
				right: 0px;
				top: 5px;
				padding: 10px 15px;
			}

			.download-status.downloading {
				display: inline-block;
				margin-left: 5px;
				animation: fa-spin 2s linear infinite;

				&::before {
					content: '\f110';
					font-family: 'Font Awesome 5 Free';
					font-weight: 900;
				}
			}
		}

		> a {
			padding: 10px 45px;
			margin-right: 2px;
			transition: .167s linear;

			&:hover {
				background-color: $main-color;
			}

			&.position-left {
				float: left;
			}

			&.highlight {
				background-color: $btn-color-green;

				&:hover {
					background-color: $btn-color-green-darker;
				}
			}
		}

		input {
			position: absolute;
			top: 0;
			left: 0;
			pointer-events: none;
			opacity: 0;

			~ ul {
				position: absolute;
				grid-template-columns: 1fr;
				top: 50px;
				right: 0;
				z-index: 1;
				display: none;
				width: 30%;
				max-height: 300px;
				overflow-y: auto;
				padding: 15px 0;
				border-radius: $border-radius;
				box-shadow: 1px 1px 1px #0003;;
				background-color: #2952AB;
				color: $inputs-color;
				font-size: .9em;

				li {
					a {
						display: inline-block;
						width: 100%;
						padding: 10px 32px;
						text-align: center;
						color: inherit;
						text-decoration: inherit;
						transition: background-color .167 linear;

						&:hover {
							background-color: #FFF3;
						}
					}
				}
			}

			&:checked ~ ul {
				display: block;
			}
		}
	}

	/* ícone de carregamento usado nos botões dos menus de exportação */
	.download-status.downloading {
		display: inline-block;
		margin-left: 5px;
		animation: fa-spin 2s linear infinite;

		&::before {
			content: '\f110';
			font-family: 'Font Awesome 5 Free';
			font-weight: 900;
		}
	}

	/* tooltips */
	.tooltip:hover {
		position: relative;

		&.warning {
			--color: #455;
			--bg-color: #FBF9CE;
		}

		&.error {
			--color: #544;
			--bg-color: #FDCECE;
		}

		&.info {
			--color: #445;
			--bg-color: #CEE2FD;
		}

		&.success {
			--color: #454;
			--bg-color: #CEFDD5;
		}

		&::before {
			content: '';
			position: absolute;
			top: 35px;
			left: 0;
			z-index: 2;
			// width: 20px;
			// height: 20px;
			border-top: 15px solid transparent;
			border-right: 15px solid var(--bg-color);
			border-bottom: 15px solid var(--bg-color);
			border-left: 15px solid transparent;

		}

		&::after {
			content: attr(data-tooltip-content);
			position: absolute;
			top: 50px;
			left: 0;
			z-index: 2;
			max-width: 100%;
			min-height: 30px;
			padding: 10px 20px;
			border-radius: $border-radius;
			text-align: left;
			background-color: var(--bg-color);
			color: var(--color);
		}
	}

	.multiselect__tags {
		padding: 8px 40px 0 0 !important;
		border-radius: 0;
		border: none !important;
		background: transparent !important;
		font-family: $font-family;
		color: $font-color;
		font-size: .875em;
	}

	.multiselect__single, .multiselect__placeholder {
		background: transparent !important;
		font-weight: $font-weight-placeholder-bolder !important;
		font-family: 'Roboto Condensed', 'Roboto', sans-serif !important;
		font-size: .875rem !important;
		color: $font-color !important;
	}

	.multiselect__placeholder {
		margin-left: 5px;
	}

	.multiselect__single {
		margin-top: 5px;
	}
</style>

// Global fade effect. This effect is used to make the transition between pages
<style>
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>

// Errors
<style>
	.errors {
		margin-top: 10px;
		color: #f00;
	}

	.is-invalid, .is_invalid {
		border: 1px solid tomato;
	}
</style>

<style lang="scss">
.search-section {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 45px;
	margin-top: 20px;
	border-radius: 5px;
	background: #ffffff;
	padding: 0 16px;

	label {
		font-family: $font-family;
		color: $font-color;
		font-size: 1em;
	}

	input {
		border: none;
		outline: none;
		background-color: transparent;
		width: 100%;
		margin-left: 12px;
		font-family: $font-family;
		color: $font-color;
		font-size: $font-size-input;

	}
	input::placeholder {
		font-family: $font-family;
		font-weight: $font-weight-placeholder-bolder;
		color: $font-color;
		font-size: $font-size-placeholder;
	}
}
.select-section {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 45px;
	margin-top: 20px;
	border-radius: 5px;
	background: #ffffff;

	label {
		font-family: $font-family;
		color: $font-color;
		font-size: 1em;
	}
}
.select-section-input {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 45px;
	border-radius: 5px;
	background: $inputs-color;

	label {
		font-family: $font-family;
		color: $font-color;
		font-size: 1em;
	}
}
</style>
